import { useState } from "react";
import { assetUrl, localized, pageUrl } from "../utils.jsx";
import { Icon } from "../Icon.jsx";

const socSplunkMenu = {
  id: "static-soc-splunk",
  menu_value: "SQURA SOC in collaboration with SPLUNK",
  menu_value_id: "SQURA SOC in collaboration with SPLUNK",
  menu_link: "solutions/detect/SOC-SPLUNK",
  menu_link_id: "solutions/detect/SOC-SPLUNK",
  children: [],
};

function menusWithSocSplunk(menus = []) {
  return menus.map((item) => {
    if (!/(^|\/)solutions?(\/|$)/i.test(item.menu_link || "")) return item;
    return {
      ...item,
      children: (item.children || []).map((group) => {
        if (!/^detect$/i.test(group.menu_value || "")) return group;
        const children = group.children || [];
        if (children.some((child) => child.id === socSplunkMenu.id))
          return group;
        return { ...group, children: [...children, socSplunkMenu] };
      }),
    };
  });
}

function DesktopMenu({ item, lang }) {
  const [activeGroup, setActiveGroup] = useState(0);
  const children = item.children || [];
  const href = pageUrl(localized(item, "menu_link", lang));
  const isIndustries =
    /(^|\/)industr(?:ies|i)(\/|$)/i.test(href) &&
    children.length > 0 &&
    children.every((child) => !child.children?.length);
  return (
    <div className="sq-react-nav__item">
      <a href={href}>{localized(item, "menu_value", lang)}</a>
      {isIndustries && (
        <div className="sq-react-nav__dropdown is-industries">
          <div className="sq-react-nav__links">
            {children.map((child) => (
              <a
                key={child.id}
                href={pageUrl(localized(child, "menu_link", lang))}
              >
                {localized(child, "menu_value", lang)}
              </a>
            ))}
          </div>
        </div>
      )}
      {children.length > 0 && !isIndustries && (
        <div className="sq-react-nav__dropdown">
          <div className="sq-react-nav__groups">
            {children.map((child, index) => (
              <button
                key={child.id}
                type="button"
                className={activeGroup === index ? "is-active" : ""}
                onMouseEnter={() => setActiveGroup(index)}
                onFocus={() => setActiveGroup(index)}
              >
                {localized(child, "menu_value", lang)}
              </button>
            ))}
          </div>
          <div className="sq-react-nav__links">
            {(children[activeGroup]?.children || []).map((child) => (
              <a
                key={child.id}
                href={pageUrl(localized(child, "menu_link", lang))}
              >
                {localized(child, "menu_value", lang)}
              </a>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export function SiteHeader({ config, onSearch }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, labels, menus, urls } = config;
  const navigationMenus = menusWithSocSplunk(menus);
  return (
    <>
      <header className="sq-react-header">
        <div className="sq-react-alertbar">
          <img src={assetUrl("templates/fe/icons/emergency.svg")} alt="" />
          <span>{labels["contact-desc"]}</span>
          <a href="tel:14052">SQURA Helpline 14052</a>
        </div>
        <div className="sq-react-header__inner">
          <button
            type="button"
            className="sq-react-header__mobile-button"
            onClick={() => setMobileOpen((current) => !current)}
            aria-label={mobileOpen ? "Tutup menu" : "Buka menu"}
            aria-expanded={mobileOpen}
          >
            <Icon name={mobileOpen ? "close" : "menu"} />
          </button>
          <a
            href={urls.home}
            className="sq-react-header__brand"
            aria-label="SQURA home"
          >
            <img
              src={assetUrl("templates/fe/images/squra.png")}
              alt="SQURA Cyber Security"
            />
          </a>
          <nav className="sq-react-nav" aria-label="Menu utama">
            {navigationMenus.map((item) => (
              <DesktopMenu key={item.id} item={item} lang={lang} />
            ))}
            <div className="sq-react-nav__item">
              <a href={urls.resources}>Resources</a>
            </div>
          </nav>
          <div className="sq-react-header__actions">
            <button
              type="button"
              className="sq-icon-button"
              onClick={onSearch}
              aria-label="Cari"
            >
              <Icon name="search" />
            </button>
            <a className="sq-primary-link" href={urls.consult}>
              {labels["consult-with-us-btn"]}
            </a>
            <div className="sq-language-switch" aria-label="Pilih bahasa">
              <a
                className={lang === "EN" ? "is-active" : ""}
                href={urls.homeEn}
              >
                EN
              </a>
              <a
                className={lang === "ID" ? "is-active" : ""}
                href={urls.homeId}
              >
                ID
              </a>
            </div>
          </div>
          <button
            type="button"
            className="sq-react-header__mobile-search"
            onClick={onSearch}
            aria-label="Cari"
          >
            <Icon name="search" />
          </button>
        </div>
      </header>
      {mobileOpen && (
        <nav className="sq-react-mobile-nav" aria-label="Menu utama seluler">
          {navigationMenus.map((item) => (
            <details
              key={item.id}
              open={!item.children?.length ? undefined : false}
            >
              <summary>
                <a href={pageUrl(localized(item, "menu_link", lang))}>
                  {localized(item, "menu_value", lang)}
                </a>
                {item.children?.length > 0 && <Icon name="expand_more" />}
              </summary>
              {item.children?.length > 0 && (
                <div>
                  {item.children
                    .flatMap((child) => child.children || [child])
                    .map((child) => (
                      <a
                        key={child.id}
                        href={pageUrl(localized(child, "menu_link", lang))}
                      >
                        {localized(child, "menu_value", lang)}
                      </a>
                    ))}
                </div>
              )}
            </details>
          ))}
          <a href={urls.resources}>Resources</a>
          <a className="sq-primary-link" href={urls.consult}>
            {labels["consult-with-us-btn"]}
          </a>
          <div className="sq-language-switch">
            <a className={lang === "EN" ? "is-active" : ""} href={urls.homeEn}>
              EN
            </a>
            <a className={lang === "ID" ? "is-active" : ""} href={urls.homeId}>
              ID
            </a>
          </div>
        </nav>
      )}
    </>
  );
}

export function SearchPanel({ open, onClose, config }) {
  if (!open) return null;
  return (
    <dialog
      open
      className="sq-overlay"
      aria-modal="true"
      aria-labelledby="search-title"
    >
      <section className="sq-search-panel">
        <div>
          <span className="sq-section-kicker">Search</span>
          <h2 id="search-title">
            {config.labels["title-1-search"]} {config.labels["title-2-search"]}
          </h2>
        </div>
        <form method="GET" action={config.urls.search}>
          <label className="sq-visually-hidden" htmlFor="homepage-search">
            Keywords
          </label>
          <input
            id="homepage-search"
            name="txtSearch"
            placeholder={config.labels["placeholder-search"]}
            required
          />
          <button className="sq-primary-button" type="submit">
            {config.labels.search}
          </button>
        </form>
        <button
          type="button"
          className="sq-modal-close"
          onClick={onClose}
          aria-label="Tutup pencarian"
        >
          <Icon name="close" />
        </button>
      </section>
    </dialog>
  );
}
